//@ts-nocheck
import { getSearchVars } from "../../routes/router";

export default class Route {

  // 'SEF, normal'
  static builder(income: { to: string; data: {} | string }) {
    const { to, data } = income;
    if (to === "SEF") {
      let url = `?`;
      if (typeof data === "object") {
        for (let i in data) {
          // @ts-ignore
          url += `${i}=${data[i]}&`;
        }
        url = url.slice(0, -1);
      } else {
        if (data.includes("/ARC/")) {
          const search = data.includes("?") ? Route.getSearchVars(data) : {};
          const [route] = data.replace("/ARC/", "").split("?");
          const array = route.split("/");
          //todo:بقیه آرایه اضافه نشده
          url += `app=${array[0]}&view=${array[1]}`;
          for (let i in search) {
            // @ts-ignore
            url += `${i}=${search[i]}`;
          }
        }
      }
      return url;
    } else if (to === "normal") {
      let objectList = data;
      if (typeof data === "string") {
        objectList = Route.getSearchVars(data);
      }
      let url = `/ARC/${objectList["app"]}/${objectList["view"]}/`;

      for (let i in objectList) {
        if (i !== "app" && i !== "view") {
          url += `${objectList[i]}/`;
        }
      }
      return url;
    }
  }

  static toNormalRoute(location) {

    let convert = "";
    if (location.pathname !== "/" && !location.pathname.includes("ARC")) {
      if (location.pathname && location.pathname.includes("?app")) {

        const searchVar = getSearchVars(
          `${location.pathname}${location.search || ""}`
        );

        let newTo = `/ARC`;
        if (
          location.pathname?.includes("?app=shop&view=product") &&
          location.pathname?.includes("slug")
        ) {
          const queryParams = new URLSearchParams(location.pathname);
          let newPath = "/ARC";
          let newQueryString = "";
          queryParams.forEach((value, key) => {
            if (key === "app") {
              newPath += `/${value}`;
            } else if (key === "view") {
              newPath += `/${value}`;
            } else if (key !== "slug") {
              newQueryString += `/${value}`;
            } else if (key === "slug") {
              newQueryString += `?slug=${value}`;
            }
          });

          newTo = newPath + newQueryString;
        } else if (!location.pathname.includes("hashCode")) {
          const queryParams = new URLSearchParams(location.pathname);
          let newPath = "/ARC";
          let newQueryString = "";
          queryParams.forEach((value, key) => {
            if (key === "app") {
              newPath += `/${value}`;
            } else if (key === "view") {
              newPath += `/${value}`;
            } else {
              // Build the new query string for remaining parameters
              /*             if (newQueryString.length === 0) {
                newQueryString += '?';
              } else {
                newQueryString += '&';
              }
              newQueryString += `${key}=${value}`;*/

              newQueryString += `/${value}`;
            }
          });

          newTo = newPath + newQueryString;
        } else {
          newTo += `/${searchVar.app}/${searchVar.view}/${searchVar?.ID}/${searchVar.hashCode}`;
        }

        if (
          location.pathname?.includes("app=shop") &&
          location.pathname?.includes("view=receipt")
        ) {
          newTo = `/ARC/${searchVar.app}/${searchVar.view}?`;
          for (let i in searchVar) {
            if (i !== "app" && i !== "view") {
              newTo += `${i}=${searchVar[i]}&`;
            }
          }
          if (newTo[newTo.length - 1] === "&") {
            newTo = newTo.substring(0, newTo.length - 1);
          }
        }
        convert = newTo;
      }
    }

    return convert;
  }

  static toNormalRouteVar(input) {
    let convert = "";
    if (input !== "/" && !input.includes("ARC")) {
      if (input[0]==='/') {
        input = input.substring(1);
      }
      if (input && input.includes("?app")) {
        const searchVar = getSearchVars(input);

        let newTo = `/ARC`;

        if (!input.includes("hashCode")) {
          const queryParams = new URLSearchParams(input);
          let newPath = "/ARC";
          let newQueryString = "";
          queryParams.forEach((value, key) => {
            if (key === "app") {
              newPath += `/${value}`;
            } else if (key === "view") {
              newPath += `/${value}`;
            } else {
              // Build the new query string for remaining parameters
              /*             if (newQueryString.length === 0) {
                newQueryString += '?';
              } else {
                newQueryString += '&';
              }
              newQueryString += `${key}=${value}`;*/

              newQueryString += `/${value}`;
            }
          });

          newTo = newPath + newQueryString;
        } else {
          newTo += `/${searchVar.app}/${searchVar.view}/${searchVar?.ID}/${searchVar.hashCode}`;
        }

        if (input?.includes("app=shop") && input?.includes("view=receipt")) {
          newTo = `/ARC/${searchVar.app}/${searchVar.view}?`;
          for (let i in searchVar) {
            if (i !== "app" && i !== "view") {
              newTo += `${i}=${searchVar[i]}&`;
            }
          }
          if (newTo[newTo.length - 1] === "&") {
            newTo = newTo.substring(0, newTo.length - 1);
          }
        }
        convert = newTo;
      }
    }

    return convert || input;
  }

  static getSearchVars(str: string) {
    const params = decodeURI(str);
    const splits = params.split("?");
    let newParams = splits.length ? splits[1] : params;
    let filters: any = {};
    if (params) {
      const list = newParams.split("&");
      let object: any = {};
      for (let i in list) {
        let ignore = false;
        let accept = true;
        let [key, value] = list[i].split("=");
        if (key.includes("!")) {
          key = key.replace("!", "");
          ignore = true;
        }
        //اگر : بعد از مساوی باشد نباید داخل لیست بیاید
        if (key.includes(":")) {
          key = key.replace(":", "");
          accept = false;
        }

        if (accept) {
          if (key.includes("[")) {
            const array = key.split("[");
            let originalKey = array[0];
            if (ignore) {
              originalKey = `!${originalKey}`;
            }
            array.shift();
            // let object = { [originalKey]: {} };
            if (!object[originalKey]) {
              object[originalKey] = {};
            }
            const loopArray = [];
            for (let i = 0; i < array.length; i++) {
              if (array[i].includes("]")) {
                const index = array[i].split("]")[0];
                if (i === 0) {
                  if (array.length === 1) {
                    object[originalKey][index] = value;
                  } else {
                    if (!object[originalKey][index]) {
                      object[originalKey][index] = {};
                    }
                  }
                  loopArray.push(index);
                } else {
                  //todo:اینجا باید برای آرایه یا آبجکت چند بعدی لوپ بخوره
                  // let temp = { ...object[originalKey] };
                  // for (let j = 0; j < loopArray.length; j++) {
                  //   temp = temp[loopArray[j]];
                  // }
                  // temp[index] = value;
                  object[originalKey][loopArray[0]][index] = value;
                }
              }
            }
            filters = { ...filters, ...object };
          } else {
            if (ignore) {
              key = `!${key}`;
            }
            filters[key] = value;
          }
        }
      }
    }

    return filters;
  }

  static parseURLParams(url) {
    let params = {};
    let parser = new URLSearchParams(url.split('?')[1]);

    for (let [key, value] of parser.entries()) {
      if (key !== "HTTP_VIEWMODE") {
        params[key] = isNaN(value) ? value : Number(value);
      }
    }

    return params;
  }

  static addToRouter(url , key, value) {
    url = new URL(url);

    // Use URLSearchParams to modify the query parameters
    const params = new URLSearchParams(url.search);

    // Set the new key-value pair
    params.set(key, value);

    // Update the search part of the URL
    url.search = params.toString();

    // Return the updated URL as a string
    return url.toString();
  }

  static removeQueryParam(url, param) {
    let urlObj = new URL(url);
    let params = urlObj.searchParams;

    params.delete(param);

    return urlObj.toString()
  }

  static updateQueryStringParameter(url, key, value) {
    const urlObj = new URL(url);
    urlObj.searchParams.set(key, value);
    return urlObj.toString();
  }
}

function buildQueryString(params, prefix = "") {
  const query = Object.keys(params).map((key) => {
    const value = params[key];
    const fullKey = prefix ? `${prefix}[${key}]` : key;

    if (typeof value === "object" && value !== null) {
      return buildQueryString(value, fullKey);
    } else {
      return `${encodeURIComponent(fullKey)}=${encodeURIComponent(value)}`;
    }
  });

  return query.join("&");
}
